import { render, staticRenderFns } from "./SoftwareUpdate.vue?vue&type=template&id=1fc22020&scoped=true"
import script from "./SoftwareUpdate.vue?vue&type=script&lang=js"
export * from "./SoftwareUpdate.vue?vue&type=script&lang=js"
import style0 from "./SoftwareUpdate.vue?vue&type=style&index=0&id=1fc22020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc22020",
  null
  
)

export default component.exports